import React from "react";
import { useMsal } from "@azure/msal-react";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { Button } from "react-bootstrap";

/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
  const { instance, accounts } = useMsal();
  //console.log(accounts);

  const handleLogout = (logoutType) => {
    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });
    } else if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  };

  return (
    <DropdownButton
      variant="warning"
      className="ml-auto"
      //drop="start"
      //title="Sign Out"
      title={accounts ? accounts[0].name : "Sign Out"}
    >
      {/*       <Dropdown.Item as="button" onClick={() => handleLogout("popup")}>
        Sign out using Popup
      </Dropdown.Item> */}
      <Dropdown.Item as="button" onClick={() => handleLogout("redirect")}>
        Sign out
      </Dropdown.Item>
    </DropdownButton>
    /*     <Button
      variant="secondary"
      className="ml-auto"
      title="Sign out"
      onClick={() => handleLogout("redirect")}
    >
      Sign out
    </Button> */
  );
};
